import { axiosInstance } from "helpers";

export async function updateBrandingAndColors(data) {
  return await axiosInstance
    .post("updatefeaturesettings", data)
    .then((res) => res.data)
}